<script setup>
// Figma Mobile 2004:2936 (375 x 6777) 본문 — 파일 xsS20cl9Iwm2XO7WPQkg54
//
// tools/figma/jsx2vue.mjs 변환물에 아래만 적용했다. 손으로 정리하지 말 것.
//   · Figma 폰트 토큰 → Tailwind 클래스
//   · 브라우저 크롬 목업 + 공통 상단(시세바·내비) + 로그인 말풍선 제거
//     → 공용 SiteHeader 로 대체한다
//   · 상단 목업 57px 만큼 최상위 자식을 위로 당김
//     (본문 시작 = 공용 상단 높이 96, 캔버스 폭 375)
//
// 캔버스 높이 6720 (뷰의 DESIGN_HEIGHT).
import imgRectangle240649922 from '@/assets/figma/91cc8a7a4339412c6a9fcdb56d5cae083168bed7.png'
import img17 from '@/assets/figma/2e5a98cc887dcecc7fa8875287b8b7ea1853de78.png'
import imgRotatedInstance2 from '@/assets/figma/7f372d8da4ebf9733add19253caff4f6d9973012.png'
import imgRotatedInstance3 from '@/assets/figma/d34f763655cec48f258c78ec143f3285bd0e5360.png'
import imgFrame2117923685 from '@/assets/figma/d0ce0f15c30a47089f5a533187e76b40e4875c0d.png'
import imgFrame2117923686 from '@/assets/figma/1928015760801cea315d284cee327af06fa5660b.png'
import imgFrame2117923687 from '@/assets/figma/eba6741617ec0cbf87ffc3eb656ec9b81b864c2b.png'
import imgFrame2117923688 from '@/assets/figma/b74fb19b504aac05425fdb6a0192c8c5c27939ae.png'
import imgFrame2117923689 from '@/assets/figma/c1a08bcd161ad359b61af86a566dfee1c2c7d693.png'
import imgFrame2117923690 from '@/assets/figma/d8d94b3cfb2cb118cefad5c4b95e32cd4788fe44.png'
import imgFrame2117923691 from '@/assets/figma/2dc97862039b46a0463091c166b703de345779cf.png'
import imgFrame2117923692 from '@/assets/figma/d48617ff11bebe18c6dd78319dd22325aacda035.png'
import imgFrame2117923693 from '@/assets/figma/96cbce7e0468c282cde778494a55bd299d2c3d91.png'
import imgFrame2117923694 from '@/assets/figma/6cf2c17ca9943718b65ff1042b9f13b34925b724.png'
import imgRectangle240649899 from '@/assets/figma/eca2f44caf1aeec6eaaa50ee99636386a5fd57f4.png'
import imgRectangle240649552 from '@/assets/figma/7259bb94e4a6c4b6e6637409570604f6b460028a.png'
import imgRectangle240649553 from '@/assets/figma/ae06fc57764c58b506cbd10413918fa5ecd87915.png'
import imgRectangle240649554 from '@/assets/figma/717f71da3bae928020d4cf00000884e27c29ecdd.png'
import imgRectangle240649548 from '@/assets/figma/c2d0b138a5f7ff156ad50faafdad3f129f6ba1de.png'
import imgRectangle240649555 from '@/assets/figma/7faa11dd122aa0df962f5c352660b3eebbe9263e.png'
import imgRectangle240649556 from '@/assets/figma/5564bb9217f7802644b767aa2a94a53218f81a85.png'
import imgRectangle240649557 from '@/assets/figma/0902bce3698d5477e05292a8cff16520cce9abe9.png'
import imgAsi1 from '@/assets/figma/17120927140354d8ddcb33c6b6122a57228813aa.png'
import imgImage12 from '@/assets/figma/0852bf42617039e8bd9220ea960f1992b675158f.png'
import imgIso1 from '@/assets/figma/f9954d663361961f69b548ddb256b4fb2cfb7dd8.png'
import imgHallmarkResearchInstitute1 from '@/assets/figma/077b5a117c45071b9e779dac9b25f74be0c3b224.png'
import img1 from '@/assets/figma/2d1be5512ae1a5a59cf85b8e4916a832650e6b47.png'
import imgRectangle240649515 from '@/assets/figma/3e676817fa010f9bdaf5f81db5065c1db6a571fa.png'
import imgImage219 from '@/assets/figma/f763b24c4a0c99fcd59705971c5e8bd83a47eadb.png'
import imgRectangle240649521 from '@/assets/figma/6d2e3e329bc8c351920f35905fa2ff9dbeae14d8.png'
import imgRectangle240649517 from '@/assets/figma/b7abf16161c98845e5858b9ffca2aee3f6301bee.png'
import imgRectangle240649522 from '@/assets/figma/fad49f63e07cdb2142248212421711afa5300618.png'
import imgImage34 from '@/assets/figma/78ce6959d56388ad5e289427ae3c7ee07f8e736a.png'
import imgRectangle240649516 from '@/assets/figma/b26505789b8b6f1db72154069d6ea30763cab8bd.png'
import imgImage14 from '@/assets/figma/b237e4b548ed1c95ff3d9192584bc80bd658aefb.png'
import imgRectangle240649523 from '@/assets/figma/bab724b993bd0646b26898d5d8df630813abc83b.png'
import imgRectangle240649518 from '@/assets/figma/55e30a7df93902b561d3b9c2ca9b51183d18e6a5.png'
import imgRectangle240649519 from '@/assets/figma/937d05ae4062d9f4b786bd767ba67f233be344d7.png'
import imgImage205 from '@/assets/figma/2f359bd563968b2508391edb22b0f3227dbb459b.png'
import imgRectangle240649520 from '@/assets/figma/c18781a720d862cf026c35125d0428957afe3950.png'
import imgImage233 from '@/assets/figma/c3cce4dcd79473d4bcead92c48b5243c9ae9c469.png'
import imgChangeColorHere from '@/assets/figma/5c960e40dfe9dc6585ad0a6efae2902c53ea4e04.png'
import imgDisplayFrame from '@/assets/figma/10be8110865394191da0a1a0acbe7fb243194e56.png'
import img2 from '@/assets/figma/c2096845300b51cff365909140844f496292491a.png'
import img3 from '@/assets/figma/f617b84e890d0c0b8c0fab5c2d775ce49122d692.png'
import imgChangeColorHere1 from '@/assets/figma/8fed1021d80d51f46df8908746c02e2c5600e6dc.png'
import imgDisplayFrame1 from '@/assets/figma/80a14c9f52232ff860d2014c687d3e473bb452ba.png'
import img4 from '@/assets/figma/511ac0b271381adc719c6d1dd33f817f906dd596.png'
import img5 from '@/assets/figma/20ab1e761648698d5f2f04c808f6e234327bd334.png'
import imgEllipse32 from '@/assets/figma/2529ec906b15228f530c7ce5ec8528a5b8756aad.svg'
import imgEllipse86 from '@/assets/figma/5839c5784f690c254c8ac8b8df49870c6f152c44.svg'
import imgVector24 from '@/assets/figma/4a0b4c3a8eb4c3350d6c445c817ba427e23de94c.svg'
import imgVector19 from '@/assets/figma/ab7d9e3f0dce473777e74f60f0962a5f0b9f326e.svg'
import imgVector25 from '@/assets/figma/797ff0e7acc67dda3145c27d376a9b64cb1c6370.svg'
import imgVector26 from '@/assets/figma/4ef6dc427ed204c3dbdb5830121ba04eec6312ee.svg'
import imgGroup2117905670 from '@/assets/figma/407971fd8b694af9649c6cfcc2f5d746c7d8f64c.svg'
import imgEllipse76 from '@/assets/figma/5bb23608eb850f2d71a9ee001d6e0ca27dfde7e3.svg'
import imgEllipse83 from '@/assets/figma/34824d7db5018bde818d42bfc46e9d228ac6f945.svg'
import imgVector17 from '@/assets/figma/13ff093119de097cf22e865ee01872633ceb89f8.svg'
import imgGroup from '@/assets/figma/bb94e87129a6a452079fff9824ecdb91d9c585ca.svg'
import imgEllipse30 from '@/assets/figma/84ee7bc4248ded4f94831939a4ba26d1b3617550.svg'
import imgEllipse31 from '@/assets/figma/d1f68cb88398a377776dcf620dcbc687a36ea1a8.svg'
import imgGroup2117905546 from '@/assets/figma/ce758decb7c2faf9d9463ba477e511651d0b1f29.svg'
import img from '@/assets/figma/acd5f7c87c982b2941319a4c4413948994182eed.svg'
import imgGroup2147228381 from '@/assets/figma/3838a8bec6ce07eaa7d7cb9bd38986285bc1511f.svg'
import imgGroup2147228114 from '@/assets/figma/070b4327f7e3cb2979b201801179d023ea03da60.svg'
import imgCalendarMinus from '@/assets/figma/1477d289b15727dd1859a35cdfd49d06fc49a074.svg'
import imgGroup2147228376 from '@/assets/figma/7f920cef196504a16dfbf02dee28b35005b13c1f.svg'
import imgGroup2117905671 from '@/assets/figma/19b1a31f06ba6fbeaa5fae1a50b10f2131ab72b7.svg'
import imgGroup3 from '@/assets/figma/908d2ae33b5018c6e566d1cd338477110d9915b9.svg'
import imgGroup4 from '@/assets/figma/9cdc1ec4342b10e1c3dbf02e73420483673aab85.svg'
import imgGroup2117905615 from '@/assets/figma/30fcce7599b4ff6016b03bf044c82088baacc4f8.svg'
import imgGroup2117905616 from '@/assets/figma/f088a2d5d62696ca6d453ce88a49e12d880346aa.svg'
import imgFix from '@/assets/figma/8b963a1c2f676a6164b996e6fff475e572354d53.svg'
import imgFix1 from '@/assets/figma/f6a60d19752e568622d38eef21089c66494c8d86.svg'
import imgFix2 from '@/assets/figma/fc6101f56f446367124a90031d9f71d54451c145.svg'
import imgFix3 from '@/assets/figma/2af2360bef928f2e152ad2191edb13165ec7534b.svg'
import imgSocialYouTubeStyle4E5968 from '@/assets/figma/a71de3f1e2bb4c1f48439f29bd13af864b50a7b3.svg'
import imgSocialFacebookStyle4E5968 from '@/assets/figma/3f5ef5f98bc5337120dd2b525b96ddc97cb6b0c9.svg'
import imgSocialXExTwitterStyleBlack from '@/assets/figma/561a7f01ac48ca06e6e1bf89cc88b32f043f9f77.svg'
import imgSocialInstagramStyleBlack from '@/assets/figma/f2ed1851d84918d7b641b3fce68105c8f5da6618.svg'
const style1 = { backgroundImage: "linear-gradient(117.29417798526417deg, rgba(255, 249, 235, 0.8) 9.3674%, rgba(255, 251, 243, 0.8) 101.83%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 100%)" }
const style2 = { backgroundImage: "linear-gradient(130.72646927746354deg, rgba(255, 237, 199, 0.8) 11.231%, rgba(255, 248, 230, 0.8) 119.93%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 100%)" }
const style3 = { backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 115 230' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'><rect x='0' y='0' height='100%' width='100%' fill='url(%23grad)' opacity='0.5'/><defs><radialGradient id='grad' gradientUnits='userSpaceOnUse' cx='0' cy='0' r='10' gradientTransform='matrix(-7.5358 -20.162 10.11 -5.7813 75.358 201.62)'><stop stop-color='rgba(255,182,22,1)' offset='0'/><stop stop-color='rgba(255,187,40,1)' offset='0.125'/><stop stop-color='rgba(255,193,58,1)' offset='0.25'/><stop stop-color='rgba(255,204,94,1)' offset='0.5'/><stop stop-color='rgba(255,216,130,1)' offset='0.75'/><stop stop-color='rgba(255,227,166,1)' offset='1'/></radialGradient></defs></svg>\")" }
const style4 = { containerType: "size" }
const style5 = { containerType: "size" }
const style6 = { containerType: "size" }
const style7 = { containerType: "size" }
const style8 = { containerType: "size" }
const style9 = { containerType: "size" }
const style10 = { containerType: "size" }
const style11 = { containerType: "size" }
const style12 = { containerType: "size" }
const style13 = { containerType: "size" }
const style14 = { fontVariationSettings: '"CTGR" 0, "wdth" 100' }
const style15 = { backgroundImage: "linear-gradient(100.96359092533291deg, rgb(6, 5, 5) 3.4363%, rgb(208, 155, 0) 248.16%)" }
const style16 = { containerType: "size" }
const style17 = { containerType: "size" }
const style18 = { backgroundImage: "linear-gradient(104.77954193123766deg, rgb(6, 5, 5) 3.4363%, rgb(208, 155, 0) 248.16%)" }
const style19 = { containerType: "size" }
const style20 = { containerType: "size" }
const style21 = { containerType: "size" }
const style22 = { backgroundImage: "linear-gradient(97.26947332732925deg, rgb(0, 0, 0) 1.133%, rgb(34, 22, 2) 174.35%)" }
const style23 = { backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)" }
const style24 = { backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)" }
const style25 = { maskImage: `url("${imgFix}")` }
const style26 = { maskImage: `url("${imgFix}")` }
const style27 = { maskImage: `url("${imgFix}")` }
const style28 = { maskImage: `url("${imgFix}"), url("${img2}")` }
const style29 = { maskImage: `url("${imgFix2}")` }
const style30 = { maskImage: `url("${imgFix2}")` }
const style31 = { maskImage: `url("${imgFix2}")` }
const style32 = { maskImage: `url("${imgFix2}"), url("${img4}")` }
</script>

<template>
    <div class="bg-white relative size-full" data-node-id="2004:2936" data-name="홈">
      <div class="absolute bg-[#fffdfa] h-[595px] left-0 overflow-clip top-[5508px] w-[375px]" data-node-id="2004:2937">
        <div class="-translate-x-1/2 absolute bottom-[-474px] h-[448px] left-[calc(50%+773px)] w-[2297px]" data-node-id="2004:2938">
          <div class="absolute inset-[-66.96%_-13.06%]">
            <img alt="" class="block max-w-none size-full" :src="imgEllipse32" />
          </div>
        </div>
        <div class="absolute content-stretch flex flex-col gap-[30px] items-start left-[15px] top-[80px] w-[340px]" data-node-id="2004:2939">
          <div class="content-stretch flex flex-col gap-[10px] items-start relative shrink-0" data-node-id="2004:2940">
            <div class="border border-[#a66e08] border-solid content-stretch flex items-center justify-center px-[10px] py-[8px] relative rounded-[999px] shrink-0" data-node-id="2004:2941">
              <p class="[word-break:break-word] font-semibold leading-[14px] not-italic relative shrink-0 text-[#a66e08] text-[11px] text-center whitespace-nowrap" data-node-id="2004:2942">{{ 'Beyond Gold & Silver' }}</p>
            </div>
            <div class="[word-break:break-word] font-bold leading-[0] not-italic relative shrink-0 text-[28px] text-black whitespace-nowrap" data-node-id="2004:2943">
              <p class="leading-[36px] mb-0">금·은 시장은 새로운 자산</p>
              <p class="leading-[36px] mb-0">생태계로 변화의 시대를</p>
              <p class="leading-[36px]">맞이하고 있습니다.</p>
            </div>
          </div>
          <div class="content-stretch flex flex-col items-start relative shrink-0 w-full" data-node-id="2004:2944">
            <div class="[word-break:break-word] font-normal leading-[0] not-italic opacity-50 relative shrink-0 text-[15px] text-black tracking-[-0.6px] w-full" data-node-id="2004:2945">
              <p class="leading-[22px] mb-0">RWA·STO 시장의 성장과 함께 실물 금·은 자산은</p>
              <p class="leading-[22px]">거래를 넘어 자산 관리와 운용의 영역으로 연결됩니다.</p>
            </div>
          </div>
        </div>
        <div class="-translate-x-1/2 absolute h-[244px] left-1/2 top-[-156px] w-[1119px]" data-node-id="2004:2946">
          <div class="absolute inset-[-122.95%_-26.81%]">
            <img alt="" class="block max-w-none size-full" :src="imgEllipse86" />
          </div>
        </div>
        <div class="absolute contents left-0 top-[292px]" data-node-id="2004:2947">
          <div class="absolute h-[275px] left-0 top-[292px] w-[375px]" data-node-id="2004:2948">
            <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgVector24" />
          </div>
          <div class="absolute flex h-[37px] items-center justify-center left-[302px] top-[328px] w-0" data-node-id="2004:2949">
            <div class="flex-none rotate-90">
              <div class="h-0 relative w-[37px]">
                <div class="absolute inset-[-0.5px_0]">
                  <img alt="" class="block max-w-none size-full" :src="imgVector19" />
                </div>
              </div>
            </div>
          </div>
          <div class="absolute flex h-[79px] items-center justify-center left-[187px] top-[357px] w-0" data-node-id="2004:2950">
            <div class="flex-none rotate-90">
              <div class="h-0 relative w-[79px]">
                <div class="absolute inset-[-0.5px_0]">
                  <img alt="" class="block max-w-none size-full" :src="imgVector25" />
                </div>
              </div>
            </div>
          </div>
          <div class="absolute flex h-[78px] items-center justify-center left-[72px] top-[384px] w-0" data-node-id="2004:2951">
            <div class="flex-none rotate-90">
              <div class="h-0 relative w-[78px]">
                <div class="absolute inset-[-0.5px_0]">
                  <img alt="" class="block max-w-none size-full" :src="imgVector26" />
                </div>
              </div>
            </div>
          </div>
          <div class="absolute contents left-[15px] top-[365px]" data-node-id="2004:2952">
            <div class="-translate-x-1/2 absolute backdrop-blur-[25px] border-l border-r border-solid border-t border-white h-[158px] left-1/2 rounded-tl-[10px] top-[437px] w-[115px]" data-node-id="2004:2953" :style="style1" />
            <p class="[word-break:break-word] absolute font-bold leading-[normal] left-[138px] not-italic text-[#81502e] text-[16px] top-[556px] tracking-[-0.16px] whitespace-nowrap" data-node-id="2004:2954">
              Vision 2027
            </p>
            <div class="[word-break:break-word] absolute font-medium leading-[0] left-[138px] not-italic opacity-50 text-[10px] text-black top-[469px] tracking-[-0.2px] whitespace-nowrap" data-node-id="2004:2955">
              <p class="leading-[13px] mb-0 whitespace-pre">Vision 2027,</p>
              <p class="leading-[13px] mb-0 whitespace-pre">RWA·STO가 이끄는</p>
              <p class="leading-[13px] whitespace-pre">{{ ' 자산 생태계의 대전환' }}</p>
            </div>
            <div class="absolute content-stretch flex items-center left-[130px] top-[437px] w-[115px]" data-node-id="2004:2956">
              <div class="bg-gradient-to-b border-[#fead04] border-b border-solid content-stretch flex flex-[1_0_0] from-[rgba(255,206,103,0)] h-[24px] items-center justify-center min-w-px pb-[7.515px] pl-[20.267px] pr-[20.495px] pt-[7.743px] relative rounded-tl-[6.832px] to-[#ffce67]" data-node-id="2004:2957">
                <p class="[word-break:break-word] font-bold leading-[12px] not-italic relative shrink-0 text-[#674100] text-[10px] text-center whitespace-nowrap" data-node-id="2004:2958">
                  RWA
                </p>
              </div>
              <div class="bg-gradient-to-b border-[#57bfff] border-b border-solid content-stretch flex flex-[1_0_0] from-[rgba(126,189,226,0)] h-[24px] items-center justify-center min-w-px pb-[7.515px] pl-[20.267px] pr-[20.495px] pt-[7.743px] relative to-[#c0e0f5]" data-node-id="2004:2959">
                <p class="[word-break:break-word] font-bold leading-[12px] not-italic relative shrink-0 text-[#00588e] text-[10px] text-center whitespace-nowrap" data-node-id="2004:2960">
                  STO
                </p>
              </div>
            </div>
            <div class="absolute backdrop-blur-[25px] border-l border-r border-solid border-t border-white h-[132px] left-[15px] rounded-tl-[10px] top-[463px] w-[115px]" data-node-id="2004:2961" :style="style2" />
            <div class="absolute border-l border-r border-solid border-t border-white h-[230px] left-[245px] rounded-tl-[10px] rounded-tr-[10px] top-[365px] w-[115px]" data-node-id="2004:2962">
              <div aria-hidden class="absolute inset-0 pointer-events-none rounded-tl-[10px] rounded-tr-[10px]">
                <img alt="" class="absolute max-w-none object-bottom rounded-tl-[10px] rounded-tr-[10px] size-full" :src="imgRectangle240649922" />
                <div class="absolute inset-0 rounded-tl-[10px] rounded-tr-[10px]" :style="style3" />
              </div>
            </div>
            <div class="-translate-x-1/2 -translate-y-1/2 absolute h-[84px] left-[calc(50%+126px)] opacity-10 overflow-clip top-[calc(50%+255.5px)] w-[93px]" data-node-id="2004:2963" data-name="globe">
              <div class="absolute inset-[20.54%_-11.57%_-23.49%_18.58%]" data-node-id="2004:2964">
                <div class="absolute inset-[-4.04%]">
                  <img alt="" class="block max-w-none size-full" :src="imgGroup2117905670" />
                </div>
              </div>
            </div>
            <div class="absolute content-center flex flex-wrap gap-[0px_2px] items-center left-[253px] opacity-50 top-[437px] w-[99px]" data-node-id="2004:2968">
              <p class="[word-break:break-word] font-medium leading-[13px] not-italic relative shrink-0 text-[10px] text-black text-center whitespace-nowrap" data-node-id="2004:2969">
                씨티뱅크 글로벌
              </p>
              <div class="relative shrink-0 size-px" data-node-id="2004:2970">
                <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgEllipse76" />
              </div>
              <p class="[word-break:break-word] font-medium leading-[13px] not-italic relative shrink-0 text-[10px] text-black text-center whitespace-nowrap" data-node-id="2004:2971">
                하나은행
              </p>
              <div class="relative shrink-0 size-px" data-node-id="2004:2972">
                <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgEllipse76" />
              </div>
              <p class="[word-break:break-word] font-medium leading-[13px] not-italic relative shrink-0 text-[10px] text-black text-center whitespace-nowrap" data-node-id="2004:2973">
                한국 IR 협의회
              </p>
            </div>
            <div class="[word-break:break-word] absolute font-bold leading-[0] left-[253px] not-italic text-[15px] text-black top-[377px] whitespace-nowrap" data-node-id="2004:2974">
              <p class="leading-[18px] mb-0">글로벌 금·은</p>
              <p class="leading-[18px]">시장 규모</p>
            </div>
            <div class="[word-break:break-word] absolute font-semibold leading-[0] left-[23px] not-italic text-[13px] text-black top-[475px] whitespace-nowrap" data-node-id="2004:2975">
              <p class="leading-[16px] mb-0">글로벌 금·은</p>
              <p class="leading-[16px]">시장 규모</p>
            </div>
            <p class="[word-break:break-word] absolute font-semibold leading-[14px] left-[253px] not-italic opacity-50 text-[10px] text-black top-[413px] tracking-[-0.2px] whitespace-nowrap" data-node-id="2004:2976">
              2030년 예상
            </p>
            <p class="[word-break:break-word] absolute font-medium leading-[14px] left-[23px] not-italic opacity-50 text-[10px] text-black top-[509px] tracking-[-0.2px] whitespace-nowrap" data-node-id="2004:2977">
              2025년 ~ 2026년
            </p>
            <div class="[word-break:break-word] absolute content-stretch flex items-center leading-[normal] left-[253px] not-italic text-[#81502e] text-[16px] top-[556px] tracking-[-0.16px] whitespace-nowrap" data-node-id="2004:2978">
              <p class="font-bold relative shrink-0" data-node-id="2004:2979">
                367
              </p>
              <p class="font-medium relative shrink-0" data-node-id="2004:2980">
                조
              </p>
            </div>
            <div class="[word-break:break-word] absolute content-stretch flex items-center leading-[normal] left-[23px] not-italic text-[#81502e] text-[16px] top-[556px] tracking-[-0.16px] whitespace-nowrap" data-node-id="2004:2981">
              <p class="font-bold relative shrink-0" data-node-id="2004:2982">
                20
              </p>
              <p class="font-medium relative shrink-0" data-node-id="2004:2983">
                조
              </p>
            </div>
          </div>
          <div class="-translate-x-1/2 absolute left-[calc(50%+114.5px)] size-[6px] top-[363px]" data-node-id="2004:2984">
            <div class="absolute inset-[-416.67%_-366.67%_-316.67%_-366.67%]">
              <img alt="" class="block max-w-none size-full" :src="imgEllipse83" />
            </div>
          </div>
          <div class="-translate-x-1/2 absolute left-[calc(50%-0.5px)] size-[6px] top-[434px]" data-node-id="2004:2985">
            <div class="absolute inset-[-416.67%_-366.67%_-316.67%_-366.67%]">
              <img alt="" class="block max-w-none size-full" :src="imgEllipse83" />
            </div>
          </div>
          <div class="-translate-x-1/2 absolute left-[calc(50%-115.5px)] size-[6px] top-[460px]" data-node-id="2004:2986">
            <div class="absolute inset-[-416.67%_-366.67%_-316.67%_-366.67%]">
              <img alt="" class="block max-w-none size-full" :src="imgEllipse83" />
            </div>
          </div>
          <div class="absolute h-0 left-px top-[384px] w-[374px]" data-node-id="2004:2987">
            <div class="absolute inset-[-0.5px_0]">
              <img alt="" class="block max-w-none size-full" :src="imgVector17" />
            </div>
          </div>
          <div class="-translate-x-1/2 absolute left-[calc(50%-0.5px)] size-[6px] top-[381px]" data-node-id="2004:2988">
            <div class="absolute inset-[-416.67%_-366.67%_-316.67%_-366.67%]">
              <img alt="" class="block max-w-none size-full" :src="imgEllipse83" />
            </div>
          </div>
        </div>
      </div>
      <div class="absolute flex inset-[55.22%_-26.65%_36.15%_-45.07%] items-center justify-center" data-node-id="2004:2989" :style="style4">
        <div class="-rotate-30 flex-none h-[hypot(28.6476cqw,54.6379cqh)] w-[hypot(71.3524cqw,-45.3621cqh)]">
          <div class="relative size-full" data-name="Group">
            <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup" />
          </div>
        </div>
      </div>
      <div class="absolute bg-[#11100e] h-[812px] left-0 overflow-clip top-0 w-[375px]" data-node-id="2004:2993">
        <div class="-translate-x-1/2 absolute contents left-[calc(50%+0.41px)] top-[542px]" data-node-id="2004:2994">
          <div class="absolute h-[133.947px] left-[142.77px] top-[542px] w-[90.28px]" data-node-id="2004:2995" data-name="17">
            <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="img17" />
          </div>
          <div class="absolute flex h-[151.661px] items-center justify-center left-[243.88px] top-[547.21px] w-[119.712px]" data-node-id="2004:2997">
            <div class="flex-none rotate-[13.85deg]">
              <div class="h-[133.947px] relative w-[90.28px]" data-name="Rotated Instance 2">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgRotatedInstance2" />
                <div class="-translate-x-1/2 -translate-y-1/2 absolute h-[133.947px] left-1/2 top-1/2 w-[90.28px]" data-node-id="2004:2998" />
              </div>
            </div>
          </div>
          <div class="absolute flex h-[160.56px] items-center justify-center left-[341.75px] top-[584.14px] w-[142.187px]" data-node-id="2004:2999">
            <div class="flex-none rotate-[27.69deg]">
              <div class="h-[133.947px] relative w-[90.28px]" data-name="Rotated Instance 3">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgRotatedInstance3" />
                <div class="-translate-x-1/2 -translate-y-1/2 absolute h-[133.947px] left-1/2 top-1/2 w-[90.28px]" data-node-id="2004:3000" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[80.13%_-56.55%_0.15%_114.85%] items-center justify-center" data-node-id="2004:3001" :style="style5">
            <div class="flex-none h-[hypot(-56.793cqw,62.6133cqh)] rotate-[41.54deg] w-[hypot(43.207cqw,37.3867cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923685" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[150.389px] items-center justify-center left-[calc(50%+398.75px)] top-[calc(50%+412.04px)] w-[161.521px]" data-node-id="2004:3002">
            <div class="flex-none rotate-[55.38deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923686" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[131.911px] items-center justify-center left-[calc(50%+452.98px)] top-[calc(50%+515.36px)] w-[157.257px]" data-node-id="2004:3003">
            <div class="flex-none rotate-[69.23deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923687" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[105.767px] items-center justify-center left-[calc(50%+480.9px)] top-[calc(50%+628.66px)] w-[143.853px]" data-node-id="2004:3004">
            <div class="flex-none rotate-[83.08deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923688" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[105.767px] items-center justify-center left-[calc(50%+480.91px)] top-[calc(50%+745.34px)] w-[143.853px]" data-node-id="2004:3005">
            <div class="flex-none rotate-[96.92deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923689" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[131.911px] items-center justify-center left-[calc(50%+452.98px)] top-[calc(50%+858.64px)] w-[157.257px]" data-node-id="2004:3006">
            <div class="flex-none rotate-[110.77deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923690" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[159.21%_-77.87%_-77.73%_134.8%] items-center justify-center" data-node-id="2004:3007" :style="style6">
            <div class="flex-none h-[hypot(-68.249cqw,-50.5958cqh)] rotate-[124.62deg] w-[hypot(-31.751cqw,49.4042cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923691" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[160.128px] items-center justify-center left-[calc(50%+321.37px)] top-[calc(50%+1049.3px)] w-[156.399px]" data-node-id="2004:3008">
            <div class="flex-none rotate-[138.46deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923692" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[177.5%_-29.05%_-97.27%_91.13%] items-center justify-center" data-node-id="2004:3009" :style="style7">
            <div class="flex-none h-[hypot(-43.7793cqw,-73.8695cqh)] rotate-[152.31deg] w-[hypot(-56.2207cqw,26.1305cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923693" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[151.661px] items-center justify-center left-[calc(50%+116.24px)] top-[calc(50%+1156.96px)] w-[119.712px]" data-node-id="2004:3010">
            <div class="flex-none rotate-[166.15deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923694" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[185.97%_37.85%_-102.46%_38.07%] items-center justify-center" data-node-id="2004:3011" :style="style8">
            <div class="flex-none h-[100cqh] rotate-180 w-[100cqw]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="img17" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[151.661px] items-center justify-center left-[calc(50%-115.43px)] top-[calc(50%+1156.96px)] w-[119.712px]" data-node-id="2004:3012">
            <div class="flex-none rotate-[-166.15deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgRotatedInstance2" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[160.56px] items-center justify-center left-[calc(50%-224.53px)] top-[calc(50%+1115.58px)] w-[142.187px]" data-node-id="2004:3013">
            <div class="flex-none rotate-[-152.31deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgRotatedInstance3" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[169.36%_114.63%_-89.08%_-56.34%] items-center justify-center" data-node-id="2004:3014" :style="style9">
            <div class="flex-none h-[hypot(56.793cqw,-62.6133cqh)] rotate-[-138.46deg] w-[hypot(-43.207cqw,-37.3867cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923685" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[150.389px] items-center justify-center left-[calc(50%-397.94px)] top-[calc(50%+961.96px)] w-[161.521px]" data-node-id="2004:3015">
            <div class="flex-none rotate-[-124.62deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923686" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[131.911px] items-center justify-center left-[calc(50%-452.17px)] top-[calc(50%+858.64px)] w-[157.257px]" data-node-id="2004:3016">
            <div class="flex-none rotate-[-110.77deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923687" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[105.767px] items-center justify-center left-[calc(50%-480.09px)] top-[calc(50%+745.34px)] w-[143.853px]" data-node-id="2004:3017">
            <div class="flex-none rotate-[-96.92deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923688" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[105.767px] items-center justify-center left-[calc(50%-480.09px)] top-[calc(50%+628.66px)] w-[143.853px]" data-node-id="2004:3018">
            <div class="flex-none rotate-[-83.08deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923689" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[131.911px] items-center justify-center left-[calc(50%-452.17px)] top-[calc(50%+515.36px)] w-[157.257px]" data-node-id="2004:3019">
            <div class="flex-none rotate-[-69.23deg]">
              <div class="h-[133.947px] relative w-[90.28px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923690" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[91.48%_134.58%_-10%_-77.65%] items-center justify-center" data-node-id="2004:3020" :style="style10">
            <div class="flex-none h-[hypot(68.249cqw,50.5958cqh)] rotate-[-55.38deg] w-[hypot(31.751cqw,-49.4042cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923691" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[80.13%_114.63%_0.15%_-56.34%] items-center justify-center" data-node-id="2004:3021" :style="style11">
            <div class="flex-none h-[hypot(56.793cqw,62.6133cqh)] rotate-[-41.54deg] w-[hypot(43.207cqw,-37.3867cqh)]">
              <div class="relative rounded-[9.813px] size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[9.813px] size-full" :src="imgFrame2117923692" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[71.94%_90.92%_8.29%_-28.83%] items-center justify-center" data-node-id="2004:3022" :style="style12">
            <div class="flex-none h-[hypot(43.7793cqw,73.8695cqh)] rotate-[-27.69deg] w-[hypot(56.2207cqw,-26.1305cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923693" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[67.39%_64.82%_13.93%_3.26%] items-center justify-center" data-node-id="2004:3023" :style="style13">
            <div class="flex-none h-[hypot(26.7774cqw,85.7542cqh)] rotate-[-13.85deg] w-[hypot(73.2226cqw,-14.2458cqh)]">
              <div class="relative rounded-[9.813px] size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[9.813px] size-full" :src="imgFrame2117923694" />
              </div>
            </div>
          </div>
        </div>
        <div class="absolute h-[264px] left-[141px] top-[721px] w-[578px]" data-node-id="2004:3024">
          <div class="absolute inset-[-113.64%_-51.9%]">
            <img alt="" class="block max-w-none size-full" :src="imgEllipse30" />
          </div>
        </div>
        <div class="absolute h-[264px] left-[-343px] top-[721px] w-[604px]" data-node-id="2004:3025">
          <div class="absolute inset-[-113.64%_-49.67%]">
            <img alt="" class="block max-w-none size-full" :src="imgEllipse31" />
          </div>
        </div>
      </div>
      <p class="-translate-x-1/2 [word-break:break-word] absolute font-normal leading-[22px] left-[calc(50%+0.5px)] not-italic text-[15px] text-center text-white top-[339px] w-[208px]" data-node-id="2004:3083">
        금과 은을 통해 시장의 흐름을 넘어,
      </p>
      <p class="-translate-x-1/2 [word-break:break-word] absolute font-normal leading-[22px] left-[calc(50%+0.5px)] not-italic text-[15px] text-center text-white top-[363px] whitespace-nowrap" data-node-id="2004:3084">
        시간이 지나도 변하지 않는 가치 그 자체를 거래합니다.
      </p>
      <div class="-translate-x-1/2 absolute content-stretch flex flex-col items-center left-[calc(50%+0.5px)] top-[855px]" data-node-id="2004:3085">
        <div class="[word-break:break-word] content-stretch flex flex-col gap-[20px] items-center leading-[0] not-italic relative shrink-0 text-black text-center whitespace-nowrap" data-node-id="2004:3086">
          <div class="font-bold relative shrink-0 text-[22px]" data-node-id="2004:3087">
            <p class="leading-[32px] mb-0">금과 은은 인류가 증명한</p>
            <p class="leading-[32px] mb-0">가장 오래된 REAL MONEY 입니다.</p>
            <p class="leading-[32px] mb-0">자산이 흔들릴 때,</p>
            <p class="leading-[32px] mb-0">금과 은은 흔들리지 않습니다.</p>
            <p class="leading-[32px]">실물은 곧 안전자산입니다.</p>
          </div>
          <div class="font-medium opacity-50 relative shrink-0 text-[16px]" data-node-id="2004:3088">
            <p class="leading-[24px] mb-0">골드나라는 금·은 거래를 넘어,</p>
            <p class="leading-[24px]">자산관리와 가치 성장까지 함께합니다.</p>
          </div>
        </div>
      </div>
      <div class="-translate-x-1/2 [word-break:break-word] absolute font-bold leading-[0] left-1/2 not-italic text-[45px] text-center text-white top-[219px] tracking-[-1.35px] whitespace-nowrap" data-node-id="2004:3089">
        <p class="leading-[50px] mb-0">Real Money is</p>
        <p class="leading-[50px]">Real Gold</p>
      </div>
      <div class="-translate-x-1/2 [word-break:break-word] absolute font-bold leading-[0] left-[calc(50%-0.5px)] not-italic text-[30px] text-black text-center top-[1273px] whitespace-nowrap" data-node-id="2004:3090">
        <p class="leading-[40px] mb-0">20년의 경험,</p>
        <p class="leading-[40px]">숫자로 증명된 신뢰</p>
      </div>
      <div class="-translate-x-1/2 absolute border border-[#a66e08] border-solid content-stretch flex items-center justify-center left-1/2 px-[10px] py-[8px] rounded-[999px] top-[1233px]" data-node-id="2004:3091">
        <p class="[word-break:break-word] font-semibold leading-[14px] not-italic relative shrink-0 text-[#a66e08] text-[11px] text-center whitespace-nowrap" data-node-id="2004:3092">
          Built on Trust. Proven by Scale
        </p>
      </div>
      <div class="absolute content-stretch flex flex-col gap-[30px] items-start left-[15px] top-[2511px] w-[340px]" data-node-id="2004:3093">
        <div class="content-stretch flex flex-col gap-[10px] items-start relative shrink-0" data-node-id="2004:3094">
          <div class="border border-[#a66e08] border-solid content-stretch flex items-center justify-center px-[10px] py-[8px] relative rounded-[999px] shrink-0" data-node-id="2004:3095">
            <p class="[word-break:break-word] font-semibold leading-[14px] not-italic relative shrink-0 text-[#a66e08] text-[11px] text-center whitespace-nowrap" data-node-id="2004:3096">
              Real Gold Market
            </p>
          </div>
          <div class="[word-break:break-word] font-bold leading-[0] not-italic relative shrink-0 text-[28px] text-black whitespace-nowrap" data-node-id="2004:3097">
            <p class="leading-[36px] mb-0">국내 최고 품질의</p>
            <p class="leading-[36px]">안전한 금,은 거래</p>
          </div>
        </div>
        <div class="[word-break:break-word] content-stretch flex flex-col gap-[5px] items-start relative shrink-0 text-black w-full" data-node-id="2004:3098">
          <p class="font-medium leading-[26px] not-italic relative shrink-0 text-[18px] w-full" data-node-id="2004:3099">
            금의 가치를 넘어, 새로운 자산 생태계로
          </p>
          <div class="font-normal font-normal leading-[0] opacity-50 relative shrink-0 text-[15px] tracking-[-0.6px] w-full whitespace-pre-wrap" data-node-id="2004:3100" :style="style14">
            <p class="leading-[22px] mb-0">Real Money is Real Gold의 브랜드 슬로건과 철학을 중심</p>
            <p class="leading-[22px] mb-0">으로 전 세계에서 가장 오래된 실물자산이자 그 가치는</p>
            <p class="leading-[22px] mb-0">{{ '글로벌 기준의 가치평가로 원화가치로 변동이 되지 않습니다. ' }}</p>
            <p class="leading-[22px] mb-0">​</p>
            <p class="leading-[22px] mb-0">대한민국에서 유일한 글로벌 품질 인증과 함량에 대한</p>
            <p class="leading-[22px] mb-0">보증을 통하여 가장 안전하게 가장 저렴한 가격 비교를 통해</p>
            <p class="leading-[22px] mb-0">{{ '실물자산의 거래를 보장합니다. ' }}</p>
            <p class="leading-[22px] mb-0">​</p>
            <p class="leading-[22px] mb-0">Real Gold Market은 오프라인 스토어와 온라인을 통합</p>
            <p class="leading-[22px] mb-0">했으며, 금. 은 실물자산의 주요 모든 브랜드의 거래와</p>
            <p class="leading-[22px] mb-0">{{ '리사이클(중매거래)거래를 연결하였습니다. ' }}</p>
            <p class="leading-[22px] mb-0">​</p>
            <p class="leading-[22px]">{{ '대한민국 중매거래 1위 거래소에서 대한민국 실물거래 1위의 금. 은 거래소로 여러분의 자산투자 포트폴리오와 자산관리로 실물자산 운용의 생태계를 만들어갑니다. ' }}</p>
          </div>
        </div>
      </div>
      <div class="absolute contents left-[15px] top-[3278px]" data-node-id="2004:3101">
        <div class="absolute h-[415px] left-[15px] rounded-[11.682px] top-[3278px] w-[345px]" data-node-id="2004:3102">
          <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[11.682px] size-full" :src="imgRectangle240649899" />
        </div>
      </div>
      <div class="-translate-x-1/2 [word-break:break-word] absolute font-medium leading-[0] left-[189px] not-italic opacity-50 text-[15px] text-black text-center top-[1373px] w-[340px]" data-node-id="2004:3103">
        <p class="leading-[22px] mb-0">거래 규모부터 콘텐츠 영향력, 전국 네트워크까지</p>
        <p class="leading-[22px] mb-0">골드나라가 쌓아온 시장의 깊이와 경쟁력을</p>
        <p class="leading-[22px]">수치로 확인할 수 있습니다.</p>
      </div>
      <div class="-translate-x-1/2 absolute content-stretch flex gap-[10px] items-start left-1/2 top-[1469px]" data-node-id="2004:3104">
        <div class="content-stretch flex items-start relative shrink-0" data-node-id="2004:3105">
          <div class="content-stretch flex flex-col items-start pl-[14px] pr-[12px] py-[10px] relative rounded-[5px] shrink-0 w-[105px]" data-node-id="2004:3106" :style="style15">
            <div class="content-stretch flex gap-[11px] items-center relative shrink-0 w-full" data-node-id="2004:3107">
              <p class="[word-break:break-word] font-medium leading-[20px] not-italic relative shrink-0 text-[15px] text-white tracking-[-0.15px] whitespace-nowrap" data-node-id="2004:3108">
                회사소개
              </p>
              <div class="overflow-clip relative shrink-0 size-[16px]" data-node-id="2004:3109" data-name="arrow-up-right">
                <div class="absolute flex inset-[18.6%_18.6%_18.64%_18.64%] items-center justify-center" data-node-id="2004:3110" :style="style16">
                  <div class="flex-none h-[100cqw] rotate-90 w-[100cqh]">
                    <div class="relative size-full">
                      <div class="absolute inset-[-5.97%_-5.98%_-4.23%_-4.23%]">
                        <img alt="" class="block max-w-none size-full" :src="imgGroup2117905546" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gradient-to-r content-stretch flex flex-col from-[#bf9c51] items-start pl-[14px] pr-[12px] py-[10px] relative rounded-[5px] shrink-0 to-[#ba841e] to-[127.25%] w-[66px]" data-node-id="2004:3113">
          <div class="content-stretch flex gap-[11px] items-center relative shrink-0 w-full" data-node-id="2004:3114">
            <p class="[word-break:break-word] font-medium leading-[20px] not-italic relative shrink-0 text-[15px] text-white tracking-[-0.15px] whitespace-nowrap" data-node-id="2004:3115">
              IR
            </p>
            <div class="overflow-clip relative shrink-0 size-[16px]" data-node-id="2004:3116" data-name="arrow-up-right">
              <div class="absolute flex inset-[18.6%_18.6%_18.64%_18.64%] items-center justify-center" data-node-id="2004:3117" :style="style17">
                <div class="flex-none h-[100cqw] rotate-90 w-[100cqh]">
                  <div class="relative size-full">
                    <div class="absolute inset-[-5.97%_-5.98%_-4.23%_-4.23%]">
                      <img alt="" class="block max-w-none size-full" :src="imgGroup2117905546" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="-translate-x-1/2 absolute content-stretch flex gap-[10px] items-start left-[calc(50%-43.5px)] top-[3044px]" data-node-id="2004:3120">
        <div class="content-stretch flex items-start relative shrink-0" data-node-id="2004:3121">
          <div class="content-stretch flex flex-col items-start pl-[14px] pr-[12px] py-[10px] relative rounded-[5px] shrink-0 w-[143px]" data-node-id="2004:3122" :style="style18">
            <div class="content-stretch flex gap-[11px] items-center relative shrink-0 w-full" data-node-id="2004:3123">
              <p class="[word-break:break-word] font-medium leading-[20px] not-italic relative shrink-0 text-[15px] text-white tracking-[-0.15px] whitespace-nowrap" data-node-id="2004:3124">
                Trade Market
              </p>
              <div class="overflow-clip relative shrink-0 size-[16px]" data-node-id="2004:3125" data-name="arrow-up-right">
                <div class="absolute flex inset-[18.6%_18.6%_18.64%_18.64%] items-center justify-center" data-node-id="2004:3126" :style="style19">
                  <div class="flex-none h-[100cqw] rotate-90 w-[100cqh]">
                    <div class="relative size-full">
                      <div class="absolute inset-[-5.97%_-5.98%_-4.23%_-4.23%]">
                        <img alt="" class="block max-w-none size-full" :src="imgGroup2117905546" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gradient-to-r content-stretch flex flex-col from-[#bf9c51] items-start pl-[14px] pr-[12px] py-[10px] relative rounded-[5px] shrink-0 to-[#ba841e] to-[127.25%] w-[105px]" data-node-id="2004:3129">
          <div class="content-stretch flex gap-[11px] items-center relative shrink-0 w-full" data-node-id="2004:3130">
            <p class="[word-break:break-word] font-medium leading-[20px] not-italic relative shrink-0 text-[15px] text-white tracking-[-0.15px] whitespace-nowrap" data-node-id="2004:3131">
              품질인증
            </p>
            <div class="overflow-clip relative shrink-0 size-[16px]" data-node-id="2004:3132" data-name="arrow-up-right">
              <div class="absolute flex inset-[18.6%_18.6%_18.64%_18.64%] items-center justify-center" data-node-id="2004:3133" :style="style20">
                <div class="flex-none h-[100cqw] rotate-90 w-[100cqh]">
                  <div class="relative size-full">
                    <div class="absolute inset-[-5.97%_-5.98%_-4.23%_-4.23%]">
                      <img alt="" class="block max-w-none size-full" :src="imgGroup2117905546" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="[word-break:break-word] absolute content-stretch flex flex-col items-start leading-[normal] left-[24px] not-italic text-white top-[1581px] w-[99px]" data-node-id="2004:3136">
        <p class="font-medium relative shrink-0 text-[12px] w-full" data-node-id="2004:3137">
          거래액
        </p>
        <p class="font-bold relative shrink-0 text-[28px] w-full" data-node-id="2004:3138">
          2,100억
        </p>
      </div>
      <div class="-translate-x-1/2 absolute content-stretch flex flex-col gap-[10px] items-start left-1/2 top-[1561px] w-[345px]" data-node-id="2004:3139">
        <div class="h-[125px] relative shrink-0 w-full" data-node-id="2004:3140">
          <div class="absolute h-[125px] left-0 rounded-[10px] top-0 w-[345px]" data-node-id="2004:3141">
            <div aria-hidden class="absolute inset-0 pointer-events-none rounded-[10px]">
              <div class="absolute bg-black inset-0 rounded-[10px]" />
              <div class="absolute inset-0 overflow-hidden rounded-[10px]">
                <img alt="" class="absolute h-[267.86%] left-[55.76%] max-w-none top-[-80.34%] w-[64.78%]" :src="imgRectangle240649552" />
              </div>
            </div>
          </div>
          <div class="absolute content-stretch flex flex-col items-start left-[15px] top-[20px] w-[100px]" data-node-id="2004:3142">
            <div class="h-[90px] relative shrink-0 w-[100px]" data-node-id="2004:3143">
              <div class="absolute content-stretch flex flex-col gap-[2px] items-start left-0 top-0 w-[100px]" data-node-id="2004:3144">
                <div class="content-stretch flex gap-[2px] items-start relative shrink-0 w-full" data-node-id="2004:3145">
                  <div class="overflow-clip relative shrink-0 size-[14px]" data-node-id="2004:3146" data-name="ChartBar">
                    <div class="absolute contents inset-[21.48%_18.41%_21.44%_18.43%]" data-node-id="2004:3147">
                      <div class="absolute bg-white inset-[21.48%_18.41%_21.44%_62.57%] rounded-[0.5px]" data-node-id="2004:3148" />
                      <div class="absolute bg-white inset-[37.78%_40.49%_21.45%_40.49%] rounded-[0.5px]" data-node-id="2004:3149" />
                      <div class="absolute bg-white inset-[54.1%_62.55%_21.44%_18.43%] rounded-[0.5px]" data-node-id="2004:3150" />
                    </div>
                  </div>
                  <p class="[word-break:break-word] font-medium leading-[normal] not-italic relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3151">
                    거래액
                  </p>
                </div>
                <p class="[word-break:break-word] font-bold leading-[normal] not-italic relative shrink-0 text-[28px] text-white w-full" data-node-id="2004:3152">
                  2,100억
                </p>
              </div>
              <p class="[word-break:break-word] absolute font-medium leading-[normal] left-0 not-italic opacity-50 text-[11px] text-white top-[77px] w-[100px]" data-node-id="2004:3153">
                2025년 기준
              </p>
            </div>
          </div>
        </div>
        <div class="h-[125px] relative shrink-0 w-full" data-node-id="2004:3154">
          <div class="absolute h-[125px] left-0 rounded-[10px] top-0 w-[345px]" data-node-id="2004:3155">
            <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[10px] size-full" :src="imgRectangle240649553" />
          </div>
          <div class="absolute left-[280px] size-[50px] top-[60px]" data-node-id="2004:3156" data-name="_寃⑸━_紐⑤뱶">
            <img alt="" class="absolute block inset-0 max-w-none size-full" :src="img" />
          </div>
          <div class="absolute content-stretch flex flex-col items-start left-[15px] top-[20px] w-[100px]" data-node-id="2004:3160">
            <div class="h-[90px] relative shrink-0 w-[100px]" data-node-id="2004:3161">
              <div class="absolute content-stretch flex flex-col gap-[2px] items-start left-0 top-0 w-[100px]" data-node-id="2004:3162">
                <div class="content-stretch flex gap-[2px] items-start relative shrink-0 w-full" data-node-id="2004:3163">
                  <div class="relative shrink-0 size-[14px]" data-node-id="2004:3164">
                    <div class="absolute h-[9.938px] left-[3.37px] top-[1.7px] w-[7.263px]" data-node-id="2004:3165">
                      <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup2147228381" />
                    </div>
                  </div>
                  <p class="[word-break:break-word] font-medium leading-[normal] not-italic relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3178">
                    회원사
                  </p>
                </div>
                <p class="[word-break:break-word] font-bold leading-[normal] not-italic relative shrink-0 text-[28px] text-white w-full" data-node-id="2004:3179">
                  7,000개
                </p>
              </div>
              <p class="[word-break:break-word] absolute font-medium leading-[normal] left-0 not-italic opacity-50 text-[11px] text-white top-[77px] whitespace-nowrap" data-node-id="2004:3180">
                한국귀금속판매업중앙회
              </p>
            </div>
          </div>
        </div>
        <div class="h-[125px] relative shrink-0 w-full" data-node-id="2004:3181">
          <div class="absolute h-[125px] left-0 rounded-[10px] top-0 w-[345px]" data-node-id="2004:3182">
            <div aria-hidden class="absolute inset-0 pointer-events-none rounded-[10px]">
              <div class="absolute bg-[#ebe8e5] inset-0 rounded-[10px]" />
              <img alt="" class="absolute max-w-none object-bottom rounded-[10px] size-full" :src="imgRectangle240649554" />
            </div>
          </div>
          <div class="absolute h-[125px] left-[248px] rounded-br-[10px] top-0 w-[97px]" data-node-id="2004:3183">
            <img alt="" class="absolute inset-0 max-w-none object-bottom pointer-events-none rounded-br-[10px] size-full" :src="imgRectangle240649548" />
          </div>
          <div class="absolute content-stretch flex flex-col items-start left-[15px] top-[20px] w-[100px]" data-node-id="2004:3184">
            <div class="h-[90px] relative shrink-0 w-[100px]" data-node-id="2004:3185">
              <div class="absolute content-stretch flex flex-col gap-[2px] items-start left-0 top-0 w-[100px]" data-node-id="2004:3186">
                <div class="content-stretch flex gap-[2px] items-start relative shrink-0 w-full" data-node-id="2004:3187">
                  <div class="overflow-clip relative shrink-0 size-[14px]" data-node-id="2004:3188" data-name="CalendarMinus">
                    <div class="absolute inset-[16.52%_13.2%_16.49%_13.17%]" data-node-id="2004:3189">
                      <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup2147228114" />
                    </div>
                  </div>
                  <p class="[word-break:break-word] font-medium leading-[normal] not-italic relative shrink-0 text-[#604412] text-[12px] whitespace-nowrap" data-node-id="2004:3194">
                    전국 직영매장
                  </p>
                </div>
                <p class="[word-break:break-word] font-bold leading-[normal] not-italic relative shrink-0 text-[28px] text-black w-full" data-node-id="2004:3195">
                  6+
                </p>
              </div>
              <p class="[word-break:break-word] absolute font-medium leading-[normal] left-0 not-italic opacity-50 text-[11px] text-black top-[77px] w-[100px]" data-node-id="2004:3196">
                서울, 부산, 경남, 인천
              </p>
            </div>
          </div>
        </div>
        <div class="h-[125px] relative shrink-0 w-full" data-node-id="2004:3197">
          <div class="absolute h-[125px] left-0 rounded-[10px] top-0 w-[345px]" data-node-id="2004:3198">
            <div aria-hidden class="absolute inset-0 pointer-events-none rounded-[10px]">
              <div class="absolute bg-[#f1e2c9] inset-0 rounded-[10px]" />
              <img alt="" class="absolute max-w-none object-bottom rounded-[10px] size-full" :src="imgRectangle240649555" />
            </div>
          </div>
          <div class="absolute content-stretch flex flex-col items-start left-[15px] top-[20px] w-[100px]" data-node-id="2004:3199">
            <div class="h-[90px] relative shrink-0 w-[100px]" data-node-id="2004:3200">
              <div class="absolute content-stretch flex flex-col gap-[2px] items-start left-0 top-0 w-[100px]" data-node-id="2004:3201">
                <div class="content-stretch flex gap-[2px] items-start relative shrink-0 w-full" data-node-id="2004:3202">
                  <div class="relative shrink-0 size-[14px]" data-node-id="2004:3203" data-name="CalendarMinus">
                    <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgCalendarMinus" />
                  </div>
                  <p class="[word-break:break-word] font-medium leading-[normal] not-italic relative shrink-0 text-[#604412] text-[12px] whitespace-nowrap" data-node-id="2004:3206">
                    업력
                  </p>
                </div>
                <p class="[word-break:break-word] font-bold leading-[normal] not-italic relative shrink-0 text-[28px] text-black w-full" data-node-id="2004:3207">
                  20년
                </p>
              </div>
              <p class="[word-break:break-word] absolute font-medium leading-[normal] left-0 not-italic opacity-50 text-[11px] text-black top-[77px] w-[100px]" data-node-id="2004:3208">
                창업 이래
              </p>
            </div>
          </div>
        </div>
        <div class="h-[125px] relative shrink-0 w-full" data-node-id="2004:3209">
          <div class="absolute h-[125px] left-0 rounded-[10px] top-0 w-[345px]" data-node-id="2004:3210">
            <div aria-hidden class="absolute inset-0 pointer-events-none rounded-[10px]">
              <div class="absolute bg-[#ebe8e5] inset-0 rounded-[10px]" />
              <div class="absolute inset-0 overflow-hidden rounded-[10px]">
                <img alt="" class="absolute h-[-8557967574.45%] left-[1161013594.58%] max-w-none top-[12.48%] w-[-1744423602.73%]" :src="imgRectangle240649556" />
              </div>
            </div>
          </div>
          <div class="[word-break:break-word] absolute content-stretch flex flex-col h-[90px] items-start justify-between leading-[normal] left-[222px] not-italic text-white top-[20px] whitespace-nowrap" data-node-id="2004:3211">
            <div class="content-stretch flex flex-col gap-[2px] items-start justify-center relative shrink-0" data-node-id="2004:3212">
              <p class="font-medium opacity-50 relative shrink-0 text-[12px]" data-node-id="2004:3213">
                영상 누적 제작 콘텐츠
              </p>
              <p class="font-bold relative shrink-0 text-[18px]" data-node-id="2004:3214">
                3,700+
              </p>
            </div>
            <div class="content-stretch flex flex-col gap-[2px] items-start justify-center relative shrink-0" data-node-id="2004:3215">
              <p class="font-medium opacity-50 relative shrink-0 text-[12px]" data-node-id="2004:3216">
                유튜브 누적 조회수
              </p>
              <p class="font-bold relative shrink-0 text-[18px]" data-node-id="2004:3217">
                1.35+
              </p>
            </div>
          </div>
          <div class="absolute content-stretch flex flex-col items-start left-[15px] top-[20px] w-[100px]" data-node-id="2004:3218">
            <div class="h-[90px] relative shrink-0 w-[100px]" data-node-id="2004:3219">
              <div class="absolute content-stretch flex flex-col gap-[2px] items-start left-0 top-0 w-[100px]" data-node-id="2004:3220">
                <div class="content-stretch flex gap-[2px] items-start relative shrink-0 w-full" data-node-id="2004:3221">
                  <div class="overflow-clip relative shrink-0 size-[14px]" data-node-id="2004:3222" data-name="mynaui:user-solid">
                    <div class="absolute inset-[13.62%_16.51%_14.25%_16.55%]" data-node-id="2004:3223">
                      <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup2147228376" />
                    </div>
                  </div>
                  <p class="[word-break:break-word] font-medium leading-[normal] not-italic relative shrink-0 text-[#e1ccb5] text-[12px] whitespace-nowrap" data-node-id="2004:3226">
                    유튜브, SNS 구독자
                  </p>
                </div>
                <p class="[word-break:break-word] font-bold leading-[normal] not-italic relative shrink-0 text-[28px] text-white w-full" data-node-id="2004:3227">
                  100만 +
                </p>
              </div>
              <p class="[word-break:break-word] absolute font-medium leading-[normal] left-0 not-italic text-[11px] text-white top-[77px] w-[100px]" data-node-id="2004:3228">
                * 개인 채널 10만 +
              </p>
            </div>
          </div>
        </div>
        <div class="h-[125px] relative shrink-0 w-full" data-node-id="2004:3229">
          <div class="absolute h-[125px] left-0 rounded-[10px] top-0 w-[345px]" data-node-id="2004:3230">
            <div aria-hidden class="absolute inset-0 pointer-events-none rounded-[10px]">
              <div class="absolute bg-[#ebe8e5] inset-0 rounded-[10px]" />
              <img alt="" class="absolute max-w-none object-bottom rounded-[10px] size-full" :src="imgRectangle240649557" />
              <div class="absolute bg-[rgba(0,0,0,0.2)] inset-0 rounded-[10px]" />
            </div>
          </div>
          <div class="absolute content-stretch flex flex-col items-start left-[15px] top-[20px] w-[100px]" data-node-id="2004:3231">
            <div class="h-[90px] relative shrink-0 w-[100px]" data-node-id="2004:3232">
              <div class="absolute content-stretch flex flex-col gap-[2px] items-start left-0 top-0 w-[100px]" data-node-id="2004:3233">
                <div class="content-stretch flex gap-[2px] items-start relative shrink-0 w-full" data-node-id="2004:3234">
                  <div class="overflow-clip relative shrink-0 size-[14px]" data-node-id="2004:3235" data-name="CalendarMinus">
                    <div class="absolute inset-[16.96%_16.96%_17%_17.01%]" data-node-id="2004:3236">
                      <div class="absolute inset-[-6.31%]">
                        <img alt="" class="block max-w-none size-full" :src="imgGroup2117905671" />
                      </div>
                    </div>
                  </div>
                  <p class="[word-break:break-word] font-medium leading-[normal] not-italic relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3240">
                    시장규모
                  </p>
                </div>
                <p class="[word-break:break-word] font-bold leading-[normal] not-italic relative shrink-0 text-[28px] text-white w-full" data-node-id="2004:3241">
                  20조
                </p>
              </div>
              <p class="[word-break:break-word] absolute font-medium leading-[normal] left-0 not-italic opacity-50 text-[11px] text-white top-[77px] w-[114.053px]" data-node-id="2004:3242">
                25년 실물 기준 국내 시장
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="absolute content-stretch flex gap-[30px] items-center left-[15px] top-[3145px]" data-node-id="2004:3243">
        <div class="content-stretch flex flex-col gap-[15px] items-start relative shrink-0 w-[110px]" data-node-id="2004:3244">
          <p class="[word-break:break-word] font-medium leading-[18px] not-italic relative shrink-0 text-[13px] text-black w-full" data-node-id="2004:3245">
            글로벌 인증 기준
          </p>
          <div class="content-stretch flex gap-[10px] items-center leading-[0] relative shrink-0 w-full" data-node-id="2004:3246">
            <div class="grid-cols-[max-content] grid-rows-[max-content] inline-grid place-items-start relative shrink-0" data-node-id="2004:3247">
              <div class="backdrop-blur-[12.5px] bg-[rgba(0,0,0,0.05)] col-1 ml-0 mt-0 relative rounded-[8.333px] row-1 size-[50px]" data-node-id="2004:3248" />
              <div class="col-1 ml-[10px] mt-[10px] relative row-1 size-[30px]" data-node-id="2004:3249" data-name="asi 1">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgAsi1" />
              </div>
            </div>
            <div class="grid-cols-[max-content] grid-rows-[max-content] inline-grid place-items-start relative shrink-0" data-node-id="2004:3250">
              <div class="backdrop-blur-[12.5px] bg-[rgba(0,0,0,0.05)] col-1 ml-0 mt-0 relative rounded-[8.333px] row-1 size-[50px]" data-node-id="2004:3251" />
              <div class="col-1 h-[17.5px] ml-[6.67px] mt-[15.83px] relative row-1 w-[36.667px]" data-node-id="2004:3252" data-name="image 12">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgImage12" />
              </div>
            </div>
          </div>
        </div>
        <div class="content-stretch flex flex-col gap-[15px] items-start relative shrink-0 w-[170px]" data-node-id="2004:3253">
          <p class="[word-break:break-word] font-medium leading-[18px] not-italic relative shrink-0 text-[13px] text-black w-full" data-node-id="2004:3254">
            국내 품질 인증
          </p>
          <div class="content-stretch flex gap-[10px] items-center leading-[0] relative shrink-0 w-full" data-node-id="2004:3255">
            <div class="grid-cols-[max-content] grid-rows-[max-content] inline-grid place-items-start relative shrink-0" data-node-id="2004:3256">
              <div class="backdrop-blur-[12.5px] bg-[rgba(0,0,0,0.05)] col-1 ml-0 mt-0 relative rounded-[8.333px] row-1 size-[50px]" data-node-id="2004:3257" />
              <div class="col-1 h-[25.833px] ml-[9.17px] mt-[11.67px] relative row-1 w-[31.667px]" data-node-id="2004:3258" data-name="iso 1">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgIso1" />
              </div>
            </div>
            <div class="grid-cols-[max-content] grid-rows-[max-content] inline-grid place-items-start relative shrink-0" data-node-id="2004:3259">
              <div class="backdrop-blur-[12.5px] bg-[rgba(0,0,0,0.05)] col-1 ml-0 mt-0 relative rounded-[8.333px] row-1 size-[50px]" data-node-id="2004:3260" />
              <div class="col-1 ml-[10px] mt-[10px] relative row-1 size-[30px]" data-node-id="2004:3261" data-name="Hallmark Research Institute 인증, 1">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgHallmarkResearchInstitute1" />
              </div>
            </div>
            <div class="grid-cols-[max-content] grid-rows-[max-content] inline-grid place-items-start relative shrink-0" data-node-id="2004:3262">
              <div class="backdrop-blur-[12.5px] bg-[rgba(0,0,0,0.05)] col-1 ml-0 mt-0 relative rounded-[8.333px] row-1 size-[50px]" data-node-id="2004:3263" />
              <div class="col-1 h-[27.5px] ml-[9.17px] mt-[11.67px] relative row-1 w-[31.667px]" data-node-id="2004:3264" data-name="한국귀금속보석감정원 인증 1">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="img1" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="absolute bg-[#d9d9d9] h-px left-[16px] top-[3114px] w-[345px]" data-node-id="2004:3265" />
      <div class="absolute bg-[#151512] h-[878px] left-0 top-[3773px] w-[375px]" data-node-id="2004:3266" />
      <div class="absolute contents left-[-29px] top-[4244px]" data-node-id="2004:3267">
        <div class="absolute h-[24px] left-[15px] overflow-clip top-[4244px] w-[106px]" data-node-id="2004:3268" data-name="_?덉씠??1">
          <div class="absolute inset-[0_68.11%_0_0]" data-node-id="2004:3269" data-name="Group">
            <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup3" />
          </div>
          <div class="absolute inset-[3.94%_0.01%_6.15%_35.04%]" data-node-id="2004:3273" data-name="Group">
            <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup4" />
          </div>
        </div>
        <div class="absolute h-[278px] left-[-29px] top-[4293px] w-[442px]" data-node-id="2004:3281">
          <div class="absolute contents left-[186px] top-0" data-node-id="2004:3282">
            <div class="absolute h-[86px] left-[186px] rounded-[13px] top-0 w-[123px]" data-node-id="2004:3283">
              <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[13px] size-full" :src="imgRectangle240649515" />
            </div>
            <div class="absolute bottom-[263px] h-[9px] right-[139px] w-[32px]" data-node-id="2004:3284" data-name="image 219">
              <div class="absolute inset-0 overflow-hidden pointer-events-none">
                <img alt="" class="absolute h-[168.99%] left-[-1.18%] max-w-none top-[-25.54%] w-[101.42%]" :src="imgImage219" />
              </div>
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[192px] px-[5px] py-[3px] rounded-[3.568px] top-[65px]" data-node-id="2004:3285">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3286">
                골드나라 엘시티 금소녀
              </p>
            </div>
          </div>
          <div class="absolute contents left-[186px] top-[192px]" data-node-id="2004:3287">
            <div class="absolute h-[86px] left-[186px] rounded-[13px] top-[192px] w-[123px]" data-node-id="2004:3288">
              <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[13px] size-full" :src="imgRectangle240649521" />
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[192px] px-[5px] py-[3px] rounded-[3.568px] top-[257px]" data-node-id="2004:3289">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3290">
                배재한의 아우라
              </p>
            </div>
          </div>
          <div class="absolute contents left-[53px] top-0" data-node-id="2004:3291">
            <div class="absolute contents left-[53px] top-0" data-node-id="2004:3292">
              <div class="absolute h-[86px] left-[53px] rounded-[13px] top-0 w-[123px]" data-node-id="2004:3293">
                <div class="absolute inset-0 overflow-hidden pointer-events-none rounded-[13px]">
                  <img alt="" class="absolute h-[122.97%] left-0 max-w-none top-[-16.74%] w-full" :src="imgRectangle240649517" />
                </div>
              </div>
            </div>
            <div class="absolute bottom-[263px] h-[9px] right-[272px] w-[32px]" data-node-id="2004:3294" data-name="image 219">
              <div class="absolute inset-0 overflow-hidden pointer-events-none">
                <img alt="" class="absolute h-[168.99%] left-[-1.18%] max-w-none top-[-25.54%] w-[101.42%]" :src="imgImage219" />
              </div>
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[59px] px-[5px] py-[3px] rounded-[3.568px] top-[65px]" data-node-id="2004:3295">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3296">
                배재한의 금토크
              </p>
            </div>
          </div>
          <div class="absolute contents left-[53px] top-[192px]" data-node-id="2004:3297">
            <div class="absolute h-[86px] left-[53px] rounded-[13px] top-[192px] w-[123px]" data-node-id="2004:3298">
              <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[13px] size-full" :src="imgRectangle240649522" />
            </div>
            <div class="absolute h-[6px] right-[272px] top-[198px] w-[21px]" data-node-id="2004:3299" data-name="image 34">
              <div class="absolute inset-0 overflow-hidden pointer-events-none">
                <img alt="" class="absolute h-[141.94%] left-[-40.24%] max-w-none top-[-29.03%] w-[140.3%]" :src="imgImage34" />
              </div>
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[59px] px-[5px] py-[3px] rounded-[3.568px] top-[257px]" data-node-id="2004:3300">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3301">
                goldnara_aura
              </p>
            </div>
          </div>
          <div class="absolute contents left-[319px] top-0" data-node-id="2004:3302">
            <div class="absolute h-[86px] left-[319px] rounded-[13px] top-0 w-[123px]" data-node-id="2004:3303">
              <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[13px] size-full" :src="imgRectangle240649516" />
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[325px] px-[5px] py-[3px] rounded-[3.568px] top-[65px]" data-node-id="2004:3304">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3305">
                아우라 금거래소
              </p>
            </div>
          </div>
          <div class="absolute h-[9px] right-[6px] top-[6px] w-[24px]" data-node-id="2004:3306" data-name="image 14">
            <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgImage14" />
          </div>
          <div class="absolute contents left-[319px] top-[192px]" data-node-id="2004:3307">
            <div class="absolute h-[86px] left-[319px] rounded-[13px] top-[192px] w-[123px]" data-node-id="2004:3308">
              <div class="absolute inset-0 overflow-hidden pointer-events-none rounded-[13px]">
                <img alt="" class="absolute h-[124.04%] left-[-0.63%] max-w-none top-[-12.01%] w-[101.26%]" :src="imgRectangle240649523" />
              </div>
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[325px] px-[5px] py-[3px] rounded-[3.568px] top-[257px]" data-node-id="2004:3309">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3310">
                배재한의 금토크
              </p>
            </div>
          </div>
          <div class="absolute contents left-[133px] top-[96px]" data-node-id="2004:3311">
            <div class="absolute h-[86px] left-[133px] rounded-[13px] top-[96px] w-[123px]" data-node-id="2004:3312">
              <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[13px] size-full" :src="imgRectangle240649518" />
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[139px] px-[5px] py-[3px] rounded-[3.568px] top-[161px]" data-node-id="2004:3313">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3314">
                배재한 창원귀금속협회 회장
              </p>
            </div>
          </div>
          <div class="absolute contents left-0 top-[96px]" data-node-id="2004:3315">
            <div class="absolute h-[86px] left-0 rounded-[13px] top-[96px] w-[123px]" data-node-id="2004:3316">
              <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[13px] size-full" :src="imgRectangle240649519" />
            </div>
            <div class="absolute h-[11px] right-[325px] top-[102px] w-[20px]" data-node-id="2004:3317" data-name="image 205">
              <div class="absolute inset-0 overflow-hidden pointer-events-none">
                <img alt="" class="absolute h-[202.41%] left-[-10.24%] max-w-none top-[-41.83%] w-[116.86%]" :src="imgImage205" />
              </div>
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[6px] px-[5px] py-[3px] rounded-[3.568px] top-[161px]" data-node-id="2004:3318">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3319">
                절대 실패 없는 금 투자
              </p>
            </div>
          </div>
          <div class="absolute contents left-[266px] top-[96px]" data-node-id="2004:3320">
            <div class="absolute h-[86px] left-[266px] rounded-[13px] top-[96px] w-[123px]" data-node-id="2004:3321">
              <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[13px] size-full" :src="imgRectangle240649520" />
            </div>
            <div class="absolute right-[59px] size-[14px] top-[102px]" data-node-id="2004:3322" data-name="image 233">
              <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgImage233" />
            </div>
            <div class="absolute backdrop-blur-[4.46px] bg-[rgba(255,255,255,0.05)] content-stretch flex items-center justify-center left-[272px] px-[5px] py-[3px] rounded-[3.568px] top-[161px]" data-node-id="2004:3323">
              <p class="[word-break:break-word] font-medium leading-[8.027px] not-italic relative shrink-0 text-[8px] text-white whitespace-nowrap" data-node-id="2004:3324">
                골드나라 네이버 카페
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="absolute contents left-[15px] top-[3853px]" data-node-id="2004:3325">
        <div class="absolute content-stretch flex flex-col gap-[30px] items-start left-[15px] top-[3853px] w-[340px]" data-node-id="2004:3326">
          <div class="content-stretch flex flex-col gap-[10px] items-start relative shrink-0" data-node-id="2004:3327">
            <div class="border border-[#ffe3af] border-solid content-stretch flex items-center justify-center px-[10px] py-[8px] relative rounded-[999px] shrink-0" data-node-id="2004:3328">
              <p class="[word-break:break-word] font-semibold leading-[14px] not-italic relative shrink-0 text-[#ffe3af] text-[11px] text-center whitespace-nowrap" data-node-id="2004:3329">
                Media Herb
              </p>
            </div>
            <div class="[word-break:break-word] font-bold leading-[0] not-italic relative shrink-0 text-[28px] text-white whitespace-nowrap" data-node-id="2004:3330">
              <p class="leading-[36px] mb-0">Real Money Trade를</p>
              <p class="leading-[36px]">위한 미디어 허브</p>
            </div>
          </div>
          <div class="[word-break:break-word] content-stretch flex flex-col gap-[5px] items-start not-italic relative shrink-0 text-white w-full" data-node-id="2004:3331">
            <p class="font-medium leading-[26px] relative shrink-0 text-[18px] w-full" data-node-id="2004:3332">
              금,은 거래 미디어 정보
            </p>
            <div class="font-normal leading-[0] relative shrink-0 text-[15px] tracking-[-0.6px] w-full whitespace-pre-wrap" data-node-id="2004:3333">
              <p class="leading-[22px] mb-0">{{ '실물자산 시장을 움직이는 핵심 데이터를 분석하고, ' }}</p>
              <p class="leading-[22px] mb-0">경제 이슈와 글로벌 시장 변화 속에서 금과 은의 가치를 조명합니다. 시장 전망부터 투자 전략, 업계 트렌드까지</p>
              <p class="leading-[22px]">REAL GOLD만의 깊이 있는 인사이트를 만나보세요.</p>
            </div>
          </div>
        </div>
        <div class="absolute bg-gradient-to-r content-stretch flex flex-col from-[#bf9c51] items-start left-[15px] pl-[14px] pr-[12px] py-[10px] rounded-[5px] to-[#ba841e] to-[127.25%] top-[4144px] w-[118px]" data-node-id="2004:3334">
          <div class="content-stretch flex gap-[11px] items-center relative shrink-0 w-full" data-node-id="2004:3335">
            <p class="[word-break:break-word] font-medium leading-[20px] not-italic relative shrink-0 text-[15px] text-white tracking-[-0.15px] whitespace-nowrap" data-node-id="2004:3336">
              미디어허브
            </p>
            <div class="overflow-clip relative shrink-0 size-[16px]" data-node-id="2004:3337" data-name="arrow-up-right">
              <div class="absolute flex inset-[18.6%_18.6%_18.64%_18.64%] items-center justify-center" data-node-id="2004:3338" :style="style21">
                <div class="flex-none h-[100cqw] rotate-90 w-[100cqh]">
                  <div class="relative size-full">
                    <div class="absolute inset-[-5.97%_-5.98%_-4.23%_-4.23%]">
                      <img alt="" class="block max-w-none size-full" :src="imgGroup2117905546" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="absolute h-[857px] left-0 overflow-clip top-[4651px] w-[375px]" data-node-id="2004:3341">
        <div class="absolute h-[857px] left-0 top-0 w-[375px]" data-node-id="2004:3342" :style="style22" />
        <div class="absolute content-stretch flex gap-[12px] items-center left-[15px] top-[342px]" data-node-id="2004:3343">
          <div class="backdrop-blur-[10.998px] content-stretch flex items-center overflow-clip pl-[12px] pr-[10.998px] py-[10px] relative rounded-[5px] shrink-0 w-[156px]" data-node-id="2004:3344" :style="style23" data-name="App Store Download Button">
            <div class="content-stretch flex gap-[7.332px] items-center relative shrink-0" data-node-id="2004:3345">
              <div class="relative shrink-0 size-[25px]" data-node-id="2004:3346">
                <div class="absolute inset-[5.44%_15.01%_10.57%_14.98%]" data-node-id="2004:3347">
                  <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup2117905615" />
                </div>
              </div>
              <div class="[word-break:break-word] content-stretch flex flex-col gap-px items-start justify-center not-italic relative shrink-0 text-white whitespace-nowrap" data-node-id="2004:3350">
                <p class="font-normal leading-[10.264px] opacity-50 relative shrink-0 text-[10px]" data-node-id="2004:3351">
                  Download here
                </p>
                <p class="font-medium leading-[16.13px] relative shrink-0 text-[14px] tracking-[0.14px]" data-node-id="2004:3352">
                  App Store
                </p>
              </div>
            </div>
          </div>
          <div class="backdrop-blur-[10.998px] content-stretch flex items-center overflow-clip pl-[12px] pr-[10.998px] py-[10px] relative rounded-[5px] shrink-0 w-[156px]" data-node-id="2004:3353" :style="style24" data-name="App Store Download Button">
            <div class="content-stretch flex gap-[7.332px] items-center relative shrink-0" data-node-id="2004:3354">
              <div class="relative shrink-0 size-[25px]" data-node-id="2004:3355">
                <div class="absolute inset-[7.73%_7.38%_7.75%_18.66%]" data-node-id="2004:3356">
                  <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup2117905616" />
                </div>
              </div>
              <div class="[word-break:break-word] content-stretch flex flex-col gap-px items-start justify-center not-italic relative shrink-0 text-white whitespace-nowrap" data-node-id="2004:3361">
                <p class="font-normal leading-[10.264px] opacity-50 relative shrink-0 text-[10px]" data-node-id="2004:3362">
                  Download here
                </p>
                <p class="font-medium leading-[16.13px] relative shrink-0 text-[14px] tracking-[0.14px]" data-node-id="2004:3363">
                  Google Play
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="absolute contents left-[15px] top-[80px]" data-node-id="2004:3364">
          <div class="absolute content-stretch flex flex-col items-start left-[15px] top-[80px] w-[340px]" data-node-id="2004:3365">
            <div class="content-stretch flex flex-col gap-[20px] items-start relative shrink-0" data-node-id="2004:3366">
              <div class="content-stretch flex flex-col gap-[10px] items-start relative shrink-0" data-node-id="2004:3367">
                <div class="border border-[#ffe3af] border-solid content-stretch flex items-center justify-center px-[10px] py-[8px] relative rounded-[999px] shrink-0" data-node-id="2004:3368">
                  <p class="[word-break:break-word] font-semibold leading-[14px] not-italic relative shrink-0 text-[#ffe3af] text-[11px] text-center whitespace-nowrap" data-node-id="2004:3369">
                    Real Gold Trade
                  </p>
                </div>
                <div class="[word-break:break-word] bg-clip-text bg-gradient-to-l font-bold from-[#ede1ca] leading-[0] not-italic relative shrink-0 text-[28px] text-[transparent] to-white whitespace-nowrap" data-node-id="2004:3370">
                  <p class="leading-[36px] mb-0">내 손안의 손쉬운 거래</p>
                  <p class="leading-[36px] mb-0">대한민국 대표</p>
                  <p class="leading-[36px]">금, 은 중매거래</p>
                </div>
              </div>
              <div class="grid-rows-[max-content] inline-grid leading-[0] place-items-start relative shrink-0 w-full" data-node-id="2004:3371">
                <div class="col-1 content-stretch flex flex-col items-start ml-0 mt-0 relative row-1 w-full" data-node-id="2004:3372">
                  <div class="h-[22px] overflow-clip relative shrink-0 w-full" data-node-id="2004:3373">
                    <p class="[word-break:break-word] absolute font-normal leading-[22px] left-0 not-italic text-[16px] text-white top-0 w-[641px]" data-node-id="2004:3374">
                      Real Money is Real Gold Trad
                    </p>
                  </div>
                  <div class="h-[22px] overflow-clip relative shrink-0 w-[47px]" data-node-id="2004:3375">
                    <p class="[word-break:break-word] absolute font-bold leading-[22px] left-0 not-italic text-[16px] text-white top-0 w-[641px]" data-node-id="2004:3376">
                      AUGO
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="-translate-x-1/2 -translate-y-1/2 absolute h-[463px] left-[calc(50%+0.5px)] top-[calc(50%+244px)] w-[486px]" data-node-id="2004:3377">
          <div class="-translate-x-1/2 absolute contents left-[calc(50%-0.02px)] top-[0.34px]" data-node-id="2004:3378">
            <div class="absolute contents left-[118.35px] top-[20.61px]" data-node-id="2004:3379">
              <div class="-translate-x-1/2 absolute contents left-[calc(50%+96.37px)] top-[20.61px]" data-node-id="2004:3380" data-name="iPhone">
                <div class="absolute contents left-[-53.44px] top-[20.67px]" data-node-id="2004:3382" data-name="Group">
                  <div class="absolute h-[419.517px] left-[220.72px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[-102.369px_-5.578px] mask-size-[442.044px_442.044px] top-[26.19px] w-[232.441px]" data-node-id="2004:3383" :style="style25" data-name="fix">
                    <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgFix1" />
                  </div>
                  <div class="-translate-x-1/2 -translate-y-1/2 absolute h-[441.913px] left-[calc(50%+96.37px)] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[171.789px_-0.063px] mask-size-[442.044px_442.044px] top-[calc(50%+10.13px)] w-[785.624px]" data-node-id="2004:3384" :style="style26" data-name="🎨 change color here">
                    <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgChangeColorHere" />
                  </div>
                  <div class="absolute h-[441.913px] left-[-53.44px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[171.789px_-0.258px] mask-size-[442.044px_442.044px] top-[20.87px] w-[785.624px]" data-node-id="2004:3385" :style="style27" data-name="display-frame">
                    <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgDisplayFrame" />
                  </div>
                  <div class="absolute contents left-[-53.44px] top-[20.87px]" data-node-id="2004:3386" data-name="Screen">
                    <div class="absolute h-[430.047px] left-[218.7px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[-100.348px_-2.82px,_-272.137px_-2.563px] mask-size-[442.044px_442.044px,_785.624px_441.914px] top-[23.43px] w-[232.414px]" data-node-id="2004:3388" :style="style28" data-name="👈">
                      <img alt="" class="absolute block inset-0 max-w-none size-full" height="430.047" :src="img3" width="232.414" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="absolute contents left-[-74.43px] top-[0.34px]" data-node-id="2004:3389">
              <div class="-translate-x-1/2 absolute contents left-[calc(50%-82.3px)] top-[0.34px]" data-node-id="2004:3390" data-name="iPhone">
                <div class="absolute contents left-[-257.19px] top-[0.41px]" data-node-id="2004:3392" data-name="Group">
                  <div class="absolute h-[416.71px] left-[44.67px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[-119.1px_-26.578px] mask-size-[470.261px_470.261px] top-[26.92px] w-[243.767px]" data-node-id="2004:3393" :style="style29" data-name="fix">
                    <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgFix3" />
                  </div>
                  <div class="-translate-x-1/2 -translate-y-1/2 absolute h-[470.121px] left-[calc(50%-82.31px)] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[182.762px_-0.07px] mask-size-[470.261px_470.261px] top-[calc(50%+3.97px)] w-[835.771px]" data-node-id="2004:3394" :style="style30" data-name="🎨 change color here">
                    <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgChangeColorHere1" />
                  </div>
                  <div class="absolute h-[470.121px] left-[-257.19px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[182.762px_-0.281px] mask-size-[470.261px_470.261px] top-[0.63px] w-[835.771px]" data-node-id="2004:3395" :style="style31" data-name="display-frame">
                    <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgDisplayFrame1" />
                  </div>
                  <div class="absolute contents left-[-254.01px] top-[0.82px]" data-node-id="2004:3396" data-name="Screen">
                    <div class="absolute h-[409.249px] left-[45.22px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[-119.654px_-29.531px,_-299.238px_-29.055px] mask-size-[470.261px_470.261px,_835.771px_470.122px] top-[29.88px] w-[244.324px]" data-node-id="2004:3398" :style="style32" data-name="👈">
                      <img alt="" class="absolute block inset-0 max-w-none size-full" height="409.249" :src="img5" width="244.324" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="absolute bg-black bottom-0 h-[617px] left-0 w-[375px]" data-node-id="2004:3399">
        <div class="absolute bottom-[159px] contents left-[15px]" data-node-id="2004:3400">
          <p class="[word-break:break-word] absolute font-normal leading-[16px] left-[15px] not-italic opacity-30 text-[12px] text-white top-[398px] whitespace-nowrap" data-node-id="2004:3401">
            Copyright © AURA. All rights reserved.
          </p>
          <p class="[word-break:break-word] absolute bottom-[587px] font-normal leading-[18px] left-[15px] not-italic text-[13px] text-white translate-y-full whitespace-nowrap" data-node-id="2004:3402">
            실물 금 자산 거래부터 미디어, 기업 협력,실시간 거래 플랫폼까지
            <br aria-hidden />
            골드나라의 주요 서비스를 확인해보세요.
          </p>
          <div class="[word-break:break-word] absolute content-stretch flex font-semibold gap-[15px] items-start leading-[20px] left-[15px] not-italic text-[14px] text-white top-[96px] whitespace-nowrap" data-node-id="2004:3403">
            <p class="relative shrink-0" data-node-id="2004:3404">
              회사소개
            </p>
            <p class="relative shrink-0" data-node-id="2004:3405">
              실시간 거래 시세
            </p>
            <p class="relative shrink-0" data-node-id="2004:3406">
              미디어 허브
            </p>
          </div>
          <div class="[word-break:break-word] absolute content-stretch flex font-semibold gap-[15px] items-start leading-[20px] left-[15px] not-italic text-[14px] text-white top-[128px] whitespace-nowrap" data-node-id="2004:3407">
            <p class="relative shrink-0" data-node-id="2004:3408">
              중매거래
            </p>
            <p class="relative shrink-0" data-node-id="2004:3409">
              서비스 이용약관
            </p>
            <p class="relative shrink-0" data-node-id="2004:3410">
              개인정보처리방침
            </p>
          </div>
          <div class="absolute flex h-px items-center justify-center left-[15px] top-[173px] w-[345px]" data-node-id="2004:3411">
            <div class="-rotate-90 flex-none">
              <div class="bg-white h-[345px] opacity-10 relative w-px" />
            </div>
          </div>
          <div class="absolute content-stretch flex flex-col gap-[8px] items-start left-[15px] top-[194px] w-[345px]" data-node-id="2004:3412">
            <div class="content-stretch flex gap-[6px] items-center relative shrink-0" data-node-id="2004:3413">
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3414">
                AURA
              </p>
              <div class="bg-white h-[10px] opacity-30 relative shrink-0 w-px" data-node-id="2004:3415" />
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3416">
                CEO
              </p>
              <div class="bg-white h-[10px] opacity-30 relative shrink-0 w-px" data-node-id="2004:3417" />
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3418">
                배재한
              </p>
            </div>
            <div class="content-stretch flex gap-[6px] items-center relative shrink-0" data-node-id="2004:3419">
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3420">
                Business Registration No.
              </p>
              <div class="bg-white h-[10px] opacity-30 relative shrink-0 w-px" data-node-id="2004:3421" />
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3422">
                573-81-03483
              </p>
            </div>
            <div class="content-stretch flex gap-[6px] items-center relative shrink-0 w-full" data-node-id="2004:3423">
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3424">
                Email
              </p>
              <div class="bg-white h-[10px] opacity-30 relative shrink-0 w-px" data-node-id="2004:3425" />
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3426">
                goldnara4@gmail.com
              </p>
            </div>
            <div class="content-stretch flex gap-[6px] items-center relative shrink-0" data-node-id="2004:3427">
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3428">
                Address
              </p>
              <div class="bg-white h-[10px] opacity-30 relative shrink-0 w-px" data-node-id="2004:3429" />
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3430">
                서울 종로구 돈화문로5가길 1 피카디리플러스 7층 701호
              </p>
            </div>
            <div class="content-center flex flex-wrap gap-[2px_6px] items-center relative shrink-0 w-full" data-node-id="2004:3431">
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3432">
                골드나라 배재한의 금토크
              </p>
              <div class="bg-white h-[10px] opacity-30 relative shrink-0 w-px" data-node-id="2004:3433" />
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3434">
                경남 창원시 성산구 원이대로 320 시티세븐
              </p>
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3435">
                W145
              </p>
            </div>
            <div class="content-stretch flex gap-[6px] items-center relative shrink-0 w-full" data-node-id="2004:3436">
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3437">
                Number
              </p>
              <div class="bg-white h-[10px] opacity-30 relative shrink-0 w-px" data-node-id="2004:3438" />
              <p class="[word-break:break-word] font-normal leading-[16px] not-italic opacity-60 relative shrink-0 text-[12px] text-white whitespace-nowrap" data-node-id="2004:3439">
                1833-5977
              </p>
            </div>
          </div>
          <div class="absolute bottom-[159px] content-stretch flex gap-[20px] items-start right-[204px]" data-node-id="2004:3440">
            <div class="relative shrink-0 size-[24px]" data-node-id="2004:3441" data-name="Social=YouTube,Style=4E5968">
              <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgSocialYouTubeStyle4E5968" />
            </div>
            <div class="relative shrink-0 size-[24px]" data-node-id="2004:3443" data-name="Social=Facebook,Style=4E5968">
              <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgSocialFacebookStyle4E5968" />
            </div>
            <div class="relative shrink-0 size-[24px]" data-node-id="2004:3445" data-name="Social=X ex Twitter,Style=Black">
              <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgSocialXExTwitterStyleBlack" />
            </div>
            <div class="relative shrink-0 size-[24px]" data-node-id="2004:3447" data-name="Social=Instagram,Style=Black">
              <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgSocialInstagramStyleBlack" />
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
